/**
 * Off-season billing pause.
 *
 * While paused, invoices are voided in Stripe so nobody is charged. The UI
 * needs to (a) explain that clearly on the subscriptions page and (b) block
 * plan changes — an upgrade/downgrade goes through Stripe's proration and
 * would bill a customer we've told won't be billed. Cancelling stays
 * available throughout.
 *
 * To resume billing: set BILLING_PAUSED to false. Nothing else to undo.
 */
export const BILLING_PAUSED = true;

// Used in the copy shown to members, e.g. "paused until <label>".
export const BILLING_RESUME_LABEL = 'a few days after the NBA season starts';

/**
 * Off-season free-trial pause. Separate switch to BILLING_PAUSED because a
 * 7-day trial with no NBA to cover burns the customer's one trial on an empty
 * week. Disables the trial CTAs on the landing page; the pricing section is
 * unaffected and still driven by the API's `can_purchase` flag.
 */
export const FREE_TRIAL_ENABLED = false;
